// block tracker
const blockIds = [];

// function todo
// - get block ids
// - unblock all
// - count blocks on certain ids in case multiple instances of the same id run the block sequentially

export function blockScroll (id) {
    if (!blockIds.length) {
        document.body.style.overflow = 'hidden';
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.left = `-${window.scrollX}px`;
        document.body.style.right = '0';
        document.body.style.position = 'fixed';
    }

    if (blockIds.indexOf(id) == -1) blockIds.push(id);
}

export function unblockScroll (id) {
    if (blockIds.length) {
        const index = blockIds.indexOf(id);
        if (index > -1) {
            blockIds.splice(index, 1);

            if (!blockIds.length) {
                const left = parseInt(document.body.style.left || 0);
                const top = parseInt(document.body.style.top || 0);

                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.left = '';
                document.body.style.right = '';
                document.body.style.overflow = '';

                window.scrollTo(left, top * -1);
            }
        }
    }
}
